import { useEffect, useRef } from "react";
import { useLocation } from "@/lib/router-compat";
import { trackPageView, trackFunnel, type FunnelStage } from "@/lib/analytics";

/** Loggar en sidvisning vid varje ruttbyte (hoppar över /admin). */
export const usePageViewTracking = () => {
  const location = useLocation();
  const last = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;
    if (last.current === path) return;
    last.current = path;
    // liten fördröjning så document.title hunnit uppdateras
    const t = window.setTimeout(() => trackPageView(path), 250);
    return () => window.clearTimeout(t);
  }, [location.pathname]);
};

/** Loggar ett trattsteg en gång per montering. */
export const useFunnelEvent = (
  goal: string,
  stage: FunnelStage,
  options?: { formKey?: string; enabled?: boolean },
) => {
  const fired = useRef(false);
  const enabled = options?.enabled ?? true;
  const formKey = options?.formKey;

  useEffect(() => {
    if (!enabled || fired.current) return;
    fired.current = true;
    trackFunnel(formKey ? { goal, stage, formKey } : { goal, stage });
  }, [goal, stage, formKey, enabled]);
};
